import { Phone, Mail, MapPin } from 'lucide-react';
import logo from '@/assets/logo.png';

const PHONE_NUMBER = '+919633210606';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-black text-white">
      <div className="container px-4 py-12 max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-10">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img src={logo} alt="Friends On Road Cab" className="h-10 w-10 rounded-full object-cover" />
              <div>
                <span className="font-bold text-xl">Friends On Road Cab</span>
              </div>
            </div>
            <p className="text-gray-400 text-sm mb-4 leading-relaxed">
              Your trusted taxi service in Kannur, Kerala. Available 24/7 for local and outstation trips.
            </p>
            <p className="text-gray-500 text-sm italic">
              "നിങ്ങളുടെ വിശ്വസനീയ യാത്രാ പങ്കാളി"
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-bold mb-4 text-lg text-primary">Quick Links</h4>
            <ul className="space-y-3">
              {['Home', 'Vehicles', 'Packages', 'Services', 'Contact'].map((link) => (
                <li key={link}>
                  <a
                    href={`#${link.toLowerCase()}`}
                    className="text-gray-400 hover:text-primary transition-colors text-sm flex items-center gap-2"
                  >
                    <span className="w-1.5 h-1.5 bg-primary/50 rounded-full" />
                    {link}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-bold mb-4 text-lg text-primary">Services</h4>
            <ul className="space-y-3 text-sm text-gray-400">
              <li className="flex items-center gap-2">
                <span className="w-1.5 h-1.5 bg-primary/50 rounded-full" />
                Local Taxi
              </li>
              <li className="flex items-center gap-2">
                <span className="w-1.5 h-1.5 bg-primary/50 rounded-full" />
                Airport Transfer
              </li>
              <li className="flex items-center gap-2">
                <span className="w-1.5 h-1.5 bg-primary/50 rounded-full" />
                Outstation Trips
              </li>
              <li className="flex items-center gap-2">
                <span className="w-1.5 h-1.5 bg-primary/50 rounded-full" />
                Wedding Cars
              </li>
              <li className="flex items-center gap-2">
                <span className="w-1.5 h-1.5 bg-primary/50 rounded-full" />
                Tour Packages
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-bold mb-4 text-lg text-primary">Contact</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3 text-sm text-gray-400">
                <div className="w-8 h-8 rounded-full bg-primary/20 flex items-center justify-center shrink-0">
                  <MapPin className="h-4 w-4 text-primary" />
                </div>
                <span>Kannur District, Kerala, India</span>
              </li>
              <li>
                <a
                  href={`tel:${PHONE_NUMBER}`}
                  className="flex items-start gap-3 text-sm text-gray-400 hover:text-primary transition-colors"
                >
                  <div className="w-8 h-8 rounded-full bg-primary/20 flex items-center justify-center shrink-0">
                    <Phone className="h-4 w-4 text-primary" />
                  </div>
                  <span className="font-medium">{PHONE_NUMBER}</span>
                </a>
              </li>
              <li>
                <a
                  href="mailto:friendsonroadcab@email.com"
                  className="flex items-start gap-3 text-sm text-gray-400 hover:text-primary transition-colors"
                >
                  <div className="w-8 h-8 rounded-full bg-primary/20 flex items-center justify-center shrink-0">
                    <Mail className="h-4 w-4 text-primary" />
                  </div>
                  <span>friendsonroadcab@email.com</span>
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 mt-10 pt-6 text-center">
          <p className="text-gray-500 text-sm">
            © {currentYear} Friends On Road Cab. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
